import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule, DEFAULT_CURRENCY_CODE, LOCALE_ID } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { ImageCropperModule } from "ngx-image-cropper";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { Ng2SearchPipeModule } from "ng2-search-filter";
import { NgxPaginationModule } from "ngx-pagination";
import { NgxSpinnerModule } from "ngx-spinner";
import { ClipboardModule } from "ngx-clipboard";
import { EditorModule } from "@tinymce/tinymce-angular";
import { BrMaskerModule } from "br-mask";

import { ErrorInterceptor } from "./core/interceptors/error.interceptor";
import { JwtInterceptor } from "./core/interceptors/jwt.interceptor";
import { UrlInterceptor } from "./core/interceptors/url.interceptor";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SafeHtmlPipe } from "./core/pipes/safe-html.pipe";
import { LayoutsModule } from "./layouts/layouts.module";
import { AdminDialogFeedNewsComponent } from "./pages/admin-dialog-feed-news/admin-dialog-feed-news.component";

import { CroppedDialogComponent } from "./pages/cropped-dialog/cropped-dialog.component";
import { CroppedPersonalStoreComponent } from "./pages/cropped-personal-store/cropped-personal-store.component";
import { OpenFinanceDialog } from "./pages/open-finance-dialog/open-finance-dialog.component";
import { ProductsInGroupDialogComponent } from "./pages/products-in-group-dialog/products-in-group-dialog.component";
import { RequestOpenFinanceDialog } from "./pages/request-open-finance-dialog/request-open-finance-dialog.component";
import { DialogConfirmExtractComponent } from "./pages/serasa-consultation-extract/components/dilalog-confirm/dialog-confirm-extract.component";
import { SolicitationStoreDialogComponent } from "./pages/store/components/solicitation-store-dialog/solicitation-store-dialog.component";
import { ComplianceDialog } from "./pages/users/form/compliance-dialog/compliance-dialog.component";
import { SimpleDialog } from "src/app/shared/components/simple-dialog/simple-dialog.component";
import { NgxCurrencyModule } from "ngx-currency";
import { TextMaskModule } from "angular2-text-mask";

import localePt from "@angular/common/locales/pt";
import { registerLocaleData } from "@angular/common";
import { MatDialogModule } from "@angular/material/dialog";
import { MatStepperModule } from "@angular/material/stepper";
import { MatListModule } from "@angular/material/list";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatRadioModule } from "@angular/material/radio";
import { MatTabsModule } from "@angular/material/tabs";
import { ProductSolicitationDialog } from "./pages/store/components/product-solcititation-dialog/product-solicitation-dialog.component";
import { ProductDescriptionDialog } from "./pages/store/components/product-description-dialog/product-description-dialog.component";
import { AlertCustomSerasaDialog } from "./shared/components/alert-custom-serasa-dialog/alert-custom-serasa-dialog.component";
import { CustomSwitchComponent } from "./shared/components/custom-switch/custom-switch.component";
import { NgxMaskDirective, provideNgxMask } from "ngx-mask";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { MatPaginatorIntlPtBr } from "./core/functions/custom-paginator";
import { HotjarService } from "./core/services/hotjar.service";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

registerLocaleData(localePt, "pt");

@NgModule({
  declarations: [
    AppComponent,
    CroppedPersonalStoreComponent,
    CroppedDialogComponent,
    OpenFinanceDialog,
    OpenFinanceDialog,
    ProductsInGroupDialogComponent,
    RequestOpenFinanceDialog,
    AdminDialogFeedNewsComponent,
    ProductSolicitationDialog,
    ProductDescriptionDialog,
    ComplianceDialog,
    SimpleDialog,
    SolicitationStoreDialogComponent,
    AlertCustomSerasaDialog,
    DialogConfirmExtractComponent,
    SafeHtmlPipe
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    Ng2SearchPipeModule,
    NgxPaginationModule,
    NgxSpinnerModule,
    NgSelectModule,
    HttpClientModule,
    ImageCropperModule,
    MatDialogModule,
    MatStepperModule,
    MatListModule,
    MatCardModule,
    MatIconModule,
    ClipboardModule,
    FormsModule,
    ReactiveFormsModule,
    LayoutsModule,
    AppRoutingModule,
    BrMaskerModule,
    EditorModule,
    MatTooltipModule,
    MatRadioModule,
    MatTabsModule,
    NgxCurrencyModule,
    TextMaskModule,
    CustomSwitchComponent,
    NgxMaskDirective,
    MatProgressSpinnerModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: UrlInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: "pt" },
    { provide: DEFAULT_CURRENCY_CODE, useValue: "BRL" },
    { provide: MatPaginatorIntl, useClass: MatPaginatorIntlPtBr },
    provideNgxMask(),
    [HotjarService]
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
